import React, { useState, useEffect } from 'react';
import { FiMenu, FiX } from "react-icons/fi";
import '../../styles/TopNavBar.css';
import NotificationsBell from './NotificationsBell';

const TopNavBar = ({ pageTitle, userId, userType }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);

        // Toggle the mobile sidebar
        const mobileSidebar = document.querySelector('.mobile-sidebar');
        const backdrop = document.querySelector('.sidebar-backdrop');

        if (mobileSidebar) {
            mobileSidebar.classList.toggle('open');
        }

        // Handle backdrop
        if (backdrop) {
            if (!isSidebarOpen) {
                backdrop.classList.add('visible');
            } else {
                backdrop.classList.remove('visible');
                // Remove backdrop after transition completes
                setTimeout(() => {
                    if (!isSidebarOpen && backdrop.parentNode) {
                        backdrop.parentNode.removeChild(backdrop);
                    }
                }, 300);
            }
        } else if (!isSidebarOpen) {
            // Create backdrop if it doesn't exist
            const newBackdrop = document.createElement('div');
            newBackdrop.className = 'sidebar-backdrop';
            newBackdrop.onclick = () => toggleSidebar();
            document.body.appendChild(newBackdrop);

            // Need to force a reflow before adding the visible class for the transition to work
            setTimeout(() => {
                newBackdrop.classList.add('visible');
            }, 10);
        }
    };

    // Handle escape key to close sidebar
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isSidebarOpen) {
                toggleSidebar();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isSidebarOpen]);

    return (
        <div className="top-nav-bar">
            {/* Hamburger menu button at the far left */}
            <button className="hamburger-btn" onClick={toggleSidebar} aria-label="Toggle menu">
                {isSidebarOpen ? <FiX /> : <FiMenu />}
            </button>

            {/* Optional page title in the center - uncomment if needed */}
            {/* {pageTitle && <h1 className="top-nav-title">{pageTitle}</h1>} */}

            {/* Right: Notification Icon + Logo */}
            <div className="top-nav-right">
                <NotificationsBell userId={userId} userType={userType} />

                <img
                    src="/logo-purple.png"
                    alt="petBoard Logo"
                    className="logo-image"
                />
            </div>
        </div>
    );
};

export default TopNavBar;